// extracted by mini-css-extract-plugin
export default {"wrapAddressOkImg":"AddressFieldPreView_wrapAddressOkImg__SfeWZ","addressOkImg":"AddressFieldPreView_addressOkImg__togFX"};